export default "__VITE_PUBLIC_ASSET__b3859b35__"